<template>
  <div class="bg-box">
    <!-- <img src="../../../../assets/wutong/inviteBg.png" class="bg-img" /> -->
    <!-- <div class="text-box">{{ text }}<span class="inviteGold">{{ inviteGold }}</span></div> -->
    <div class="intro">
      <!-- <img class="card" src="../../../../assets/wutong/card.png" />
      <div class="right">
        <div class="intro-title">新用户奖励</div>
        <div class="intro-desc">完成首笔【出国留学缴费】后，联系客服领取50 NZD (现金或者银联卡)</div>
      </div> -->
    </div>
    <div class="form_container">
      <a-form-model class="invite-form-container" layout="vertical" ref='mobileFormRef' :model="mobileForm" >
        <div class="title">输入手机号注册</div>
      <a-input-group compact >
        <a-select v-model="mobileForm.nation_prefix" style="width: 30%;" default-value="61">
        <a-select-option v-for="item in range" :key="item.value" :value="item.value">
          {{ item.label }}
        </a-select-option>
      </a-select>
        <a-input
        class="phoneInput"
        v-model="mobileForm.mobile"
        style="width: 70%;"
          size="large"
          placeholder="手机号"
          bordered="false"
          type="text"
        />
      </a-input-group>
      <a-input
        size="large"
        class="inputCode"
        :max-length="6"
        type="text"
        v-model="mobileForm.code"
        placeholder="请输入验证码"
        bordered="false"
      >
        <a-button size="large" slot="suffix" type="primary"
        :loading="sendingCode"
        :disabled="countDown > 0 || sendingCode"
        @click="getCode">
           {{ countDown > 0 ? `${countDown}s后重发` : '获取验证码' }}
        </a-button>
      </a-input>
    <div class="submit-wrapper">
      <div @click="handleSubmit" class="submit-button" :class="{ 'mb-16': true }">
        {{ submmitLoading ? '注册中...' : '立刻注册' }}
      </div>
    </div>
    <div class="privacy-text">
      <a-checkbox v-model="agreePrivacy" @change="onChange">
        </a-checkbox>
      <span @click="agreePrivacy = !agreePrivacy" class="privacy-content">我已阅读并同意
        <router-link to="/privacy" class="color_blue">《隐私政策》</router-link></span>
    </div>
  </a-form-model>
    </div>
    <!-- <div class="new-user-coupon">新人券仅限首次留学缴费使用</div> -->
    <!-- <div class="display_wrapper">
       <div class="title">{{ stepData.title }}</div>
        <div class="step-list">
          <div v-for="(item, index) in stepData.list" :key="index" class="step-item">
            <div class="step-text">· {{ item }}</div>
          </div>
        </div>
    </div> -->
    <!-- <div class="display_wrapper">
        <div class="title">{{ ruleData.title }}</div>
          <div class="step-list">
            <div v-for="(item, index) in ruleData.list" :key="index" class="step-item">
              <div class="step-text">{{ item }}</div>
            </div>
          </div>
    </div> -->

     <a-modal
        v-model="modalVisible"
        :closable="true"
        :mask-closable="false"
        width="350px"
        centered
        :footer="null"
        @cancel="handleModalCancel"
      >
        <div class="modal-content">
          <div class="modal-title">注册成功🎉，您的新人优惠券已到账!</div>
          <div class="modal-subtitle">立即下载梧桐汇App，使用新人券享受减免!</div>
          <img class="modal-img" src="../../../../assets/img/50counpon.png" alt="提示图" style="max-width:260px; width:100%; margin-bottom:16px;" />
          <div class="modal-content">该券可用于首次留学缴费，减免手续费￥50</div>
            <div @click="goDownload" class="modal-button-text">立刻下载</div>
        </div>
      </a-modal>
  </div>
</template>
<script>
import axios from 'axios';
const stepData = {
  title: '3步获得奖励🎁',
  list: [
    '1.注册并完成实名认证',
    '2.选择汇兑币种并发起交易',
    '3.订单入账,资金实时到账'
  ]
}
const ruleData = {
  title: '活动规则',
  list: [
    '1.本活动适用于通过本页注册的新用户。',
    '2.需完成首笔【出国留学】业务且单笔实付金额单笔≥15,000 NZD。',
    '3.奖励: 50 NZD; 领取方式: 联系客服领取现金或银联卡。',
    '4.若订单取消、退款或未成功入账, 则不发放奖励。',
    '5.梧桐汇保留对活动的解释、修改与终止权。'
  ]
}

const wutongBaseUrl = 'https://admin.wutong.co.nz/api'

// const wutongBaseUrl = 'https://dev.wutong.co.nz/api'
const http = axios.create({
  baseURL: wutongBaseUrl,
  timeout: 5000, // 可选：超时设置
  headers: {
    'Content-Type': 'application/json'
  }
})

const getCodeUrl = '/app-client/auth/code'
const loginUrl = '/app-client/auth/code/bind'
const tuitionContent = '/app-client/tuition/page/content'
const iosLink = 'https://apps.apple.com/cn/app/%E6%A2%A7%E6%A1%90%E6%B1%87/id6742526842'
export default {
  components: {
  },
  watch: {
    '$route.query.code'(newCode) {
      if (newCode) {
        console.log('newCode', newCode)
        this.referrerCode = newCode
      }
    }
  },
  data () {
    return {
      stepData,
      ruleData,
      agreePrivacy: false,
      referrerCode: '',
      modalVisible: false,
      submmitLoading: false,
      range: [
        { value: '86', label: '+86' },
        { value: '64', label: '+64' },
        { value: '61', label: '+61' }
      ],
      text: '邀请你领取 ',
      inviteGold: '$50手续费减免券',
      mobileForm: {
        mobile: '',
        nation_prefix: '64',
        code: ''
      },
      sendingCode: false,
      countDown: 0,
      timer: null
    }
  },
  async mounted () {
    const code = this.$route.query.code
    if (code) {
      this.referrerCode = code
      // console.log('页面初始 code:', code)
    }
    try {
      const res = await http.get(tuitionContent)
      console.log(res)
    } catch (err) {
      console.error(err)
    }
  },

  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods:  {
    goPrivacy() {
      this.$router.push('/privacy')
    },
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    goDownload () {
      if (this.isIOS()) {
        window.location.href = iosLink
      } else {
        // window.location.href = androidLink
      }
    },
    handleModalCancel () {
      this.modalVisible = false
    },
    async handleSubmit () {
      if (this.submmitLoading) return
      if (!this.agreePrivacy) {
        this.$message.error('请先阅读并同意隐私政策')
        return
      }
      this.submmitLoading = true
      if (!this.mobileForm.mobile) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.mobileForm.code) {
        this.$message.error('请输入验证码')
      }
      if (!this.referrerCode) {
        this.$message.error('请通过邀请链接注册')
        this.submmitLoading = false
        return
      }
      try {
        const mobile = this.mobileForm.mobile.startsWith('0') ? this.mobileForm.mobile.slice(1) : this.mobileForm.mobile
        const res = await http.post(loginUrl, { mobile, nation_prefix: this.mobileForm.nation_prefix, code: this.mobileForm.code, referrer_code: this.referrerCode })
        // this.modalVisible = true
        if (res.data.error_code === 0) {
          this.$router.push('/app_register')
          // this.modalVisible = true
        } else {
          if (res.data.data.message) {
            this.$message.error(res.data.data.message)
            this.submmitLoading = false
            return
          }
          this.$message.error(res.data.message)
        }
        this.submmitLoading = false
      } catch (err) {
        console.error(err)
        this.submmitLoading = false
      }
    },
    onChange (e) {
      console.log(e)
    },
    startCountdown () {
      this.countDown = 60
      this.timer = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    async getCode () {
      if (this.sending || this.countDown > 0) return

      const nzMobileReg = /^[02]\d{5,9}$/
      const cnMobileReg = /^1[3-9]\d{9}$/
      const auMobileReg = /^[04]\d{8}$/

      const { nation_prefix, mobile } = this.mobileForm

      if (!mobile) {
        this.$message.error('请输入手机号')
        return
      }

      let isValid = false
      // console.log('nation_prefix', nation_prefix)
      if (!this.agreePrivacy) {
        this.$message.error('请先阅读并同意隐私政策')
        return
      }
      switch (nation_prefix) {
        case '64':
          isValid = nzMobileReg.test(mobile)
          break
        case '86':
          isValid = cnMobileReg.test(mobile)
          break
        case '61':
          isValid = auMobileReg.test(mobile)
          break
        default:
          this.$message.error('不支持的国家区号')
          return
      }
      if (!isValid) {
        this.$message.error('请输入正确的手机号')
        return
      }
      try {
        this.sending = true
        const mobile = this.mobileForm.mobile.startsWith('0') ? this.mobileForm.mobile.slice(1) : this.mobileForm.mobile
        const res = await http.get(getCodeUrl, { params: { mobile, nation_prefix } })
        this.$message.success('验证码已发送')
        console.log('验证码接口响应:', res)
        this.startCountdown()
      } catch (err) {
        console.error(err)
        this.$message.error('验证码发送失败，请稍后再试')
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped>
.invite-form-container >>> .ant-input {
  border-radius: 11px;
}
.intro{
  margin-top: 50vh;
  width: 90%;
  /* background: url('../../../../assets/wutong/banner.png')  no-repeat center center / 100% 100%; */
  padding: 1.5rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  .card{
    width: 58px;
    height: 44px;
  }
  .intro-title{
    color: #945012;
    font-size: 1.1rem;
    font-weight: bold;
  }
  .intro-desc{
    font-size: 12px;
    color: #BA6B23;
  }
}
.display_wrapper{
  margin-top: 1rem;
  background-color: #fff;
  border-radius: 14px;
  width: 90%;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  color: #222;
}
/* 让 form 内部 item 宽度撑满 */
.privacy-content{
  margin-left: 6px;
}
.form_container{
  background: #fff;
  border-radius: 14px;
  /* overflow: hidden; */
  /* position: absolute; */
  z-index: 10;
  margin-top: 1rem;
  padding: 1.2rem 1rem;
  /* top: 42%; */
  width: 85%;
  max-width: 400px;
  /* left: 50%; */
  display: flex;
  flex-direction: column;
  /* transform: translateX(-50%); */
}
.inviteGold{
  color:#FFC845;
}
.bg-box {
  background-image: url('../../../../assets/wutong/newbg.jpg');
  background-size: 100% 100%;
  background-position: top center;
  background-repeat: no-repeat;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
}

.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: relative;
  top: 0;
  left: 0;
  z-index: -1;
}
.text-box {
  position: absolute;
  color: #fff;
  left: 50%;
  font-size: 1.2rem;
}
.inputCover{
  width: 100%;
}
.invite-form-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.title{
  color: #060606;
  font-size: 1.1rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}
.inputCode >>> .ant-btn-primary{
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #3678FF;
}
.invite-form-container >>> .ant-input{
  border-radius: 0;
  width: 100%;
  background-color: #F3F4F8;
  border: none;
  font-size: 14px;
  box-shadow: none;
  color: #222;
  height: 50px;
  padding-right: 0 !important;
  /* border-radius: 11px; */
}
.invite-form-container >>> .ant-input. >>> .phoneInput{
  border-top-left-radius: 0;
}
.invite-form-container >>> .ant-select-selection{
  border:none;
  background-color: #F3F4F8;
  height: 50px;
  line-height: 50px;
}
.new-user-coupon{
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.invite-form-container >>> .ant-select-selection__rendered {
  height: 50px;
  line-height: 50px;
}
.submit-button{
  width: 100%;
  height: 50px;
  background-color: #3678FF;
  color: #fff;
  font-size: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
}
.privacy-text{
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  /* margin-top: 20px; */
}

/* 📱 手机端（480px 以下） */
@media screen and (max-width: 480px) {
  .bg-img {
    object-position: center center; /* 居中显示重点 */
  }
  .text-box {
    top: 16%;
    transform: translateX(-50%);
    font-size: 0.9rem;
  }
}

/* 📱 iPad / 平板（481px ~ 1024px） */
@media screen and (min-width: 481px) and (max-width: 1024px) {
  .bg-img {
    object-fit: contain; /* 完整显示，不裁剪 */
    object-position: center center;
    background-color: black; /* 你可以改成合适颜色，填补空白 */
  }
  .text-box {
    top: 16%;
    transform: translateX(-50%);
    font-size: 1rem;
  }
}

/* 🖥️ PC端（大于 1024px） */
@media screen and (min-width: 1025px) {
  .bg-img {
    object-fit: contain; /* 完整显示，不裁剪 */
    object-position: center center;
    background-color: black; /* 你可以改成合适颜色，填补空白 */
  }
  .text-box {
    top: 16%;
    transform: translateX(-50%);
    font-size: 1rem;
  }
}
.mb-16{
  margin-bottom: 16px;
}
.modal-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-title{
  color: #222;
  font-size: 16px;
  font-weight: 500;
}
.modal-subtitle{
  font-size: 14px;
  color: #666;
  margin: 8px 0 13px;
}
.modal-img{
  width: 331px;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.modal-content{
  font-size: 14px;
  color: #666;
}
.modal-button{
  width: 100%;
  margin-top: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-button-text{
  margin-top: 18px;
  width: 162px;
  height: 40px;
  background: #3678FF;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.color_blue{
  color:#3678FF
}

</style>
